import pagesNames from "../../constants/pages-names";

const strategyPageData = {
    header : {
        image : {
            name : "arabian-woman.jpg",
            alt : "People talking",
        },
        title : "Our ESG Strategy",
        subtitle : "SAB mobilises finance to support an inclusive, diverse and just transition towards a more sustainable economy. We do this by placing ESG at the heart of our organisation and businesses, and by leveraging our strategic partnership with HSBC.",
    },
    ceoSection : {
        image : {
            name : "",
            alt : "CEO (Mr. Tony Cripps)",
        },
        description : `SAB’s business success is intricately linked to its efforts on ESG. Following the presentation of the ESG Strategy in 2022 and the inaugural ESG Report last year, 2023 has seen significant progress. The Bank has strengthened its position as ESG leader in the region, and drives the momentum towards a sustainable transition.`,
        descriptionTwo : "",
        name : "Mr. Tony Cripps",
        position : "Managing Director and CEO",
    },
    sectionOne : {
        rowOne : [
            {
                image : {
                    name : "environment.jpg",
                    alt : "Mills over a field",
                },
                title : "Environment",
                subtitle : "Allocate financing towards a just and sustainable economy",
                list : [
                    <p>Support the transition of our customers to a more sustainable and diversified economy through our <b>products and services</b></p>,
                    <p>Scale up <b>sustainable financing and investments</b> to <b>SAR 34 billion by 2025,</b> supporting the Kingdom’s Vision 2030</p>,
                    <p>Measure the carbon footprint of our portfolio, and achieve <b>Net Zero by 2060</b> or sooner, with an active focus on a just transition</p>,
                    <p>Align our operations and supply chain to ambitious science-based targets and achieve key milestones by 2030, with an aim to <b>achieve Net Zero in our operations by 2035</b></p>,
                    <p>Plant <b>1 million trees</b> to offset <b>0.9 million tons</b> of CO<sub>2</sub></p>,
                ]
            },
            {
                image : null,
                title : "Governance",
                subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making",
                list : [
                    <p>Deploy an <b>ESG governance structure</b></p>,
                    <p><b>Embed ESG into all departments, functions and staff members,</b> for every financial decision to be reviewed through an ESG lens</p>,
                    <p>Partner with an international body to <b>build reporting and disclosure frameworks</b> for enhanced transparency</p>,
                    <p>Roll out an <b>updated corporate governance framework</b> in line with international best practices</p>,
                ],
            }
        ],
        rowTwo : [
            {
                image : {
                    name : "social.jpg",
                    alt : "Woman explaining idea for group of people",
                },
                title : "Social",
                subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
                list : [
                    <p>Further develop our <b>digital capabilities</b> to build sustainable finance capability amongst our customers and across the kingdom</p>,
                    <p>Ambitiously pursue playing our part in <b>closing the regional savings gap</b></p>,
                    <p>Continue to actively shape and advance the development of <b>ESG and the sustainable finance market</b> across the kingdom</p>,
                    <p>Remove barriers for <b>women and para-abled</b> for engagement in financial services, including financing for female-led enterprises</p>,
                ]
            }
        ]
    },
    titleSectionOne : {
        title : "Key Enablers"
    },
    sectionTwo : [
        {
            icon : {
                name : "education-and-future.svg",
                alt : "",
            },
            title : "Education and future skills – inspired and empowered people",
            subtitle : "SAB aims to be the best bank to work in the region, by fostering a sense of belonging, empowerment and inclusivity for all our employees. Part of this is investing in a truly diverse workforce and adapting our ways of work to match our employees’ best interest and wellbeing. SAB is also developing a robust training framework to embed ESG into our corporate culture.",
        },
        {
            icon : {
                name : "community.svg",
                alt : "",
            },
            title : "Community advancement through Corporate Social Responsibility",
            subtitle : "SAB is putting the Kingdom’s sustainable advancement at the heart of our community investment and engagement programs, leveraging our collective expertise, digital ecosystem and capacity to address pressing societal and environmental issues.",
        },
        {
            icon : {
                name : "risk-framework.svg",
                alt : "",
            },
            title : "Risk framework",
            subtitle : "To meet the needs of the future, SAB must evolve its risk modelling, policies and typologies to assess exposure to high transition risk sectors. This includes measuring ’s financed emissions, conducting scenario analysis and building pathways to support the transition.",
        },
        {
            icon : {
                name : "strategic.svg",
                alt : "",
            },
            title : "Strategic communication and marketing",
            subtitle : "For SAB’s strategy to truly succeed, all stakeholders need to understand and be on board for the journey. Transparent disclosure including the publishing of this ESG report, ESG strategy, and SAB’s future commitments will support this goal.",
        },
    ],
    titleSectionTwo : {
        title : "Our Themes",
        subtitle : "SAB’s ESG strategy is built around several core themes, which guide our decision-making and against which we report internally and throughout this report",
    },
    backgroundAndCardSection : {
        background : {
            src : "busines-strategy.jpg",
            alt : "A beautiful view of mills and fields",
        },
        card : {
            title : "Our Business Strategy with an ESG Focus",
            subtitle : "With the announcement of the Saudi Green Initiative and the formal declaration of the Kingdom’s Nationally Determined Contributions (NDC) at COP26 in 2021, SAB deployed an ambitious strategy to support the ESG initiatives laid out in the NDCs and Vision 2030. ESG has been built into SAB’s overall corporate strategy, which guides its implementation at every level of the organisation.",
            image : {
                src : "business-strategy.jpg",
                alt : "A beautiful view of mills and sea",
            },
            button : {
                text : "Read More",
                path : pagesNames.business,
            }
        }
    },
    flexViewSection : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.social
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.governance
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
};

export default strategyPageData;